webpackJsonp([135,138],{

/***/ 2448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_forms_BaseRadioGroup_vue__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_i18n_mixin__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_2__mixins_i18n_mixin__["a" /* default */])('public/views/survey')],
    components: {
        'radio-button': __WEBPACK_IMPORTED_MODULE_0__components_base_forms_BaseRadioGroup_vue__["default"],
        BCard: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["e" /* BCard */]
    },
    data: function data() {
        return {
            localValue: null
        };
    },

    props: {
        progress: {
            type: Number,
            required: true
        },
        questionnaireLength: {
            type: Number,
            required: true
        },
        question: {
            type: Object
        },
        value: {
            type: Number,
            default: null
        },
        stacked: {
            type: Boolean,
            default: false
        },
        labelsEnabled: {
            type: Boolean,
            default: false
        },
        fullWidthCard: {
            type: Boolean,
            default: false
        },
        customConditionToShowButton: {
            type: Boolean,
            default: false
        },
        customButtonText: {
            type: String
        }
    },
    created: function created() {
        var _this = this;

        this.localValue = this.value;
        this.$watch('localValue', function (value) {
            _this.$emit('input', value);
        });
        this.$watch('value', function (newValue) {
            _this.localValue = newValue;
        });
    },

    methods: {
        action: function action() {
            this.$emit('answerQuestion');
            if (this.lastQuestion) {
                this.$emit('submitQuestionnaire');
            }
        }
    },
    computed: {
        leastImportantAnswer: function leastImportantAnswer() {
            return this.question.answer[0].text;
        },
        mostImportantAnswer: function mostImportantAnswer() {
            return this.question.answer[this.question.answer.length - 1].text;
        },
        questionText: function questionText() {
            return this.customButtonText || this.question.resultText || this.$t(this.lastQuestion ? 'surveys.finish' : 'surveys.following');
        },
        lastQuestion: function lastQuestion() {
            return this.progress === this.questionnaireLength - 1;
        },
        showButton: function showButton() {
            return this.customConditionToShowButton || this.localValue != null;
        }
    }
});

/***/ }),

/***/ 2449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_date_helpers__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_colours__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_tests_helpers__ = __webpack_require__(2488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_utils_QuestionCard_vue__ = __webpack_require__(2484);











/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BCard: __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["e" /* BCard */],
        'loading-anim': function loadingAnim() {
            return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 67));
        },
        QuestionCard: __WEBPACK_IMPORTED_MODULE_9__components_utils_QuestionCard_vue__["a" /* default */]
    },
    data: function data() {
        return {
            date: new Date()
        };
    },

    methods: {
        calculateMultidimensionalDimPoints: function calculateMultidimensionalDimPoints(dimension) {
            var sum = 0;
            var total = 0;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(dimension.questions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var question = _step.value;

                    var val1 = question.answer[0].value;
                    var val2 = question.answer[question.answer.length - 1].value;
                    var ans = question.result !== null && this.opposedAnswers && this.opposedAnswers.includes(question.id) ? val1 + val2 - question.result : question.result;
                    sum = sum + ans;
                    total = total + Math.max(val1, val2);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return { sum: sum, total: total };
        },
        percentResult: function percentResult(r, totalPoints) {
            return Math.round(r * 100 / totalPoints);
        },
        save: function save(dimensions, result) {
            var percentage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

            this.$store.dispatch('tests/saveTestResult', { dimensions: dimensions, result: result, percentage: percentage || result, date: this.date, testId: this.testId, testName: this.testName, userId: this.$store.state.session.user.id });
            this.testResultsInfo(this.testId);
        },
        testResultsInfo: function testResultsInfo(testId, graphResult) {
            var result = graphResult != null ? graphResult : this.DBResults.generalResult;
            var resultInfo = {};
            switch (testId) {
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["l" /* TEST_ANXIETY_BECK */]:
                    resultInfo = {
                        tag: result <= 21 ? this.$t('tests.anxiety-beck.lowAnxiety') : result <= 35 ? this.$t('tests.anxiety-beck.moderateAnxiety') : this.$t('tests.anxiety-beck.severeAnxiety'),
                        color: result <= 21 ? __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */] : result <= 35 ? __WEBPACK_IMPORTED_MODULE_6__constants_colours__["n" /* YELLOW_COLOUR */] : __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */]
                    };
                    break;
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["m" /* TEST_CARDIOVASCULAR_RISK */]:
                    switch (true) {
                        case result < 10:
                            resultInfo = { risk: 'lowRisk', tag: this.$t('tests.cardiovascular-risk.scores.lowRisk.name'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */] };
                            break;
                        case result >= 10 && result <= 20:
                            resultInfo = { risk: 'midRisk', tag: this.$t('tests.cardiovascular-risk.scores.midRisk.name'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["n" /* YELLOW_COLOUR */] };
                            break;
                        case result > 20:
                            resultInfo = { risk: 'highRisk', tag: this.$t('tests.cardiovascular-risk.scores.highRisk.name'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */] };
                            break;
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["n" /* TEST_FINDRISK */]:
                    switch (true) {
                        case result < 7:
                            resultInfo = { tag: this.$t('tests.findrisk.scores.lowRisk'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */] };
                            break;
                        case result >= 7 && result <= 11:
                            resultInfo = { tag: this.$t('tests.findrisk.scores.lightRisk'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["h" /* GREEN_LIGHT_COLOUR */] };
                            break;
                        case result >= 12 && result <= 14:
                            resultInfo = { tag: this.$t('tests.findrisk.scores.moderateRisk'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["n" /* YELLOW_COLOUR */] };
                            break;
                        case result >= 15 && result <= 20:
                            resultInfo = { tag: this.$t('tests.findrisk.scores.highRisk'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */] };
                            break;
                        case result > 20:
                            resultInfo = { tag: this.$t('tests.findrisk.scores.veryHighRisk'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */] };
                            break;
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["p" /* TEST_INTERPERSONAL_RELATIONSHIPS */]:
                    switch (true) {
                        case result <= 70:
                            resultInfo = { tag: this.$t('tests.interpersonal-relationships.scores.lowScore.score'), description: this.$t('tests.interpersonal-relationships.scores.lowScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */] };
                            break;
                        case result <= 105:
                            resultInfo = { tag: this.$t('tests.interpersonal-relationships.scores.mid-lowScore.score'), description: this.$t('tests.interpersonal-relationships.scores.mid-lowScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["j" /* ORANGE_MID_COLOUR */] };
                            break;
                        case result <= 140:
                            resultInfo = { tag: this.$t('tests.interpersonal-relationships.scores.midScore.score'), description: this.$t('tests.interpersonal-relationships.scores.midScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["n" /* YELLOW_COLOUR */] };
                            break;
                        case result <= 160:
                            resultInfo = { tag: this.$t('tests.interpersonal-relationships.scores.mid-highScore.score'), description: this.$t('tests.interpersonal-relationships.scores.mid-highScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["h" /* GREEN_LIGHT_COLOUR */] };
                            break;
                        case result >= 161:
                            resultInfo = { tag: this.$t('tests.interpersonal-relationships.scores.highScore.score'), description: this.$t('tests.interpersonal-relationships.scores.highScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */] };
                            break;
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["w" /* TEST_SOCIAL_SKILLS */]:
                    switch (true) {
                        case result <= 66:
                            resultInfo = { tag: this.$t('tests.social-skills.scores.lowScore.score'), description: this.$t('tests.social-skills.scores.lowScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */] };
                            break;
                        case result <= 99:
                            resultInfo = { tag: this.$t('tests.social-skills.scores.mid-lowScore.score'), description: this.$t('tests.social-skills.scores.mid-lowScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["j" /* ORANGE_MID_COLOUR */] };
                            break;
                        case result <= 132:
                            resultInfo = { tag: this.$t('tests.social-skills.scores.midScore.score'), description: this.$t('tests.social-skills.scores.midScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["n" /* YELLOW_COLOUR */] };
                            break;
                        case result <= 149:
                            resultInfo = { tag: this.$t('tests.social-skills.scores.mid-highScore.score'), description: this.$t('tests.social-skills.scores.mid-highScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["h" /* GREEN_LIGHT_COLOUR */] };
                            break;
                        case result >= 150:
                            resultInfo = { tag: this.$t('tests.social-skills.scores.highScore.score'), description: this.$t('tests.social-skills.scores.highScore.description'), color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */] };
                            break;
                    }
                    break;
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["q" /* TEST_MEDITERRANEAN_DIET */]:
                    var proCon = ['heartDiseasesRisk', 'diabetesRisk', 'cancerRisk', 'cognitiveFunction', 'mentalHealth'];
                    var listOfProCon = [];
                    if (result < 8) {
                        resultInfo = {
                            tag: this.$t('tests.mediterranean-diet.scores.lowAdherence.name'),
                            color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */],
                            resultsAnalysis: this.$t('tests.mediterranean-diet.scores.lowAdherence.description'),
                            prosCons: 'consequences'
                        };
                    } else {
                        resultInfo = {
                            tag: this.$t('tests.mediterranean-diet.scores.goodAdherence.name'),
                            color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */],
                            resultsAnalysis: this.$t('tests.mediterranean-diet.scores.goodAdherence.description'),
                            prosCons: 'benefits'
                        };
                    }
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(proCon), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var p = _step2.value;

                            listOfProCon.push({ id: p, name: this.$t('tests.mediterranean-diet.' + resultInfo.prosCons + '.' + p + '.name'), description: this.$t('tests.mediterranean-diet.' + resultInfo.prosCons + '.' + p + '.description') });
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    this.$set(resultInfo, 'listOfProCon', listOfProCon);
                    break;
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["r" /* TEST_NICOTINE_DEPENDENCY */]:
                    var t = [];
                    var tips = [];
                    switch (true) {
                        case result === 0:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.noDependency.name'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */],
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.noDependency.description')
                            };
                            break;
                        case result < 12:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.lowDependency.name'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */],
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.lowDependency.description')
                            };
                            t = ['conscious', 'endDate', 'reduceDaily', 'forgetTheHabit', 'lookForSupport'];
                            break;
                        case result >= 12 && result <= 22:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.midDependency.name'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["n" /* YELLOW_COLOUR */],
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.midDependency.description')
                            };
                            t = ['motivation', 'causes', 'endDate', 'forgetTheHabit', 'relaxTechniques', 'rewards'];
                            break;
                        case result >= 22 && result <= 33:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.highDependency.name'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */],
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.highDependency.description')
                            };
                            t = ['motivation', 'causes', 'endDate', 'forgetTheHabit', 'relaxTechniques', 'rewards', 'rememberBenefits', 'healthyLifestyle'];
                            break;
                        case result > 33:
                            resultInfo = {
                                tag: this.$t('tests.nicotine-dependency.scores.veryHighDependency.name'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */],
                                resultsAnalysis: this.$t('tests.nicotine-dependency.scores.veryHighDependency.description')
                            };
                            t = ['motivation', 'causes', 'endDate', 'forgetTheHabit', 'relaxTechniques', 'rewards', 'rememberBenefits', 'healthyLifestyle'];
                            break;
                    }
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(t), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var tip = _step3.value;

                            tips.push({ name: this.$t('tests.nicotine-dependency.tips.' + tip + '.name'), description: this.$t('tests.nicotine-dependency.tips.' + tip + '.description') });
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }

                    this.$set(resultInfo, 'tips', tips);
                    break;
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["s" /* TEST_PHYSICAL_ACTIVITY */]:
                    if (this.testResultLayout(__WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["s" /* TEST_PHYSICAL_ACTIVITY */])) {
                        var testResult = this.$store.state.tests.DBResults;
                        if (testResult.generalResult >= 3000 || testResult.generalResult >= 1500 && testResult.dimensions[0].result >= 3) {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.highLevel'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */],
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.high')
                            };
                        } else if (testResult.generalResult >= 600 || testResult.dimensions[0].result >= 3 && testResult.dimensions[1].result >= 20 || testResult.dimensions[2].result + testResult.dimensions[4].result >= 5 && testResult.dimensions[3].result + testResult.dimensions[5].result >= 30) {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.moderateLevel'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["n" /* YELLOW_COLOUR */],
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.moderate')
                            };
                        } else {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.lowLevel'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */],
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.low')
                            };
                        }
                    } else {
                        if (result === 100) {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.highLevel'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */],
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.high')
                            };
                        } else if (result === 50) {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.moderateLevel'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["n" /* YELLOW_COLOUR */],
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.moderate')
                            };
                        } else {
                            resultInfo = {
                                tag: this.$t('tests.physical-activity.levels.lowLevel'),
                                color: __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */],
                                resultAnalysis: this.$t('tests.physical-activity.percentPopulationResult.low')
                            };
                        }
                    }

                    break;
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["u" /* TEST_RYFF_SCALE */]:
                    var color = result < 50 ? __WEBPACK_IMPORTED_MODULE_6__constants_colours__["k" /* RED_COLOUR */] : result < 70 ? __WEBPACK_IMPORTED_MODULE_6__constants_colours__["n" /* YELLOW_COLOUR */] : __WEBPACK_IMPORTED_MODULE_6__constants_colours__["g" /* GREEN_COLOUR */];
                    var resultAnalysis = '';
                    if (this.testResultLayout(__WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["u" /* TEST_RYFF_SCALE */])) {
                        var previousResults = this.$store.state.tests.previousTestResults;
                        if (previousResults.length === 1) {
                            resultAnalysis = this.$t('tests.ryff-scale.resultsAnalysisFirstTime');
                        } else {
                            var thisMonthResult = previousResults[previousResults.length - 1].generalResult;
                            var lastMonthResult = previousResults[previousResults.length - 2].generalResult;

                            resultAnalysis = thisMonthResult >= lastMonthResult + 5 ? this.$t('tests.ryff-scale.resultsAnalysisGood') : thisMonthResult <= lastMonthResult - 5 ? this.$t('tests.ryff-scale.resultsAnalysisBad') : this.$t('tests.ryff-scale.resultsAnalysisMedium');
                        }
                    }
                    resultInfo = { resultAnalysis: resultAnalysis, color: color };
                    break;
            }
            this.$store.commit('tests/setResultInfo', resultInfo);
            return resultInfo;
        },
        testResultLayout: function testResultLayout(testId) {
            var t = testId.replace('Test ', '').toLocaleLowerCase().replace(' ', '-');
            var alias = Object(__WEBPACK_IMPORTED_MODULE_8__helpers_tests_helpers__["a" /* testRoute */])(t);
            return this.$route.path.includes(t) || this.$route.path.includes(alias);
        },
        randomizeTest: function randomizeTest() {
            var test = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.test));
            switch (this.testId) {
                //flatten dimensions and randomize
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["t" /* TEST_PSYCHOSOCIAL_RISKS */]:
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["u" /* TEST_RYFF_SCALE */]:
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["y" /* TEST_WORK_ENVIRONMENT */]:
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["o" /* TEST_GENERAL_HEALTH */]:
                    test = test.flatMap(function (x) {
                        return x.questions;
                    }).sort(function () {
                        return Math.random() - 0.5;
                    });
                    break;
                //flatten dimensions without randomize
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["v" /* TEST_SLEEP_QUALITY */]:
                    test = test.flatMap(function (x) {
                        return x.questions;
                    }).sort();
                    break;
                //return test without reorder
                case __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["s" /* TEST_PHYSICAL_ACTIVITY */]:
                    test = test.sort();
                    break;
                //randomize test
                default:
                    test.sort(function () {
                        return Math.random() - 0.5;
                    });
                    break;
            }
            return test;
        }
    },
    computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        cQ: {
            get: function get() {
                return this.$store.state.tests.test[this.$store.state.tests.currentSlide];
            }
        },
        questionResult: {
            get: function get() {
                return this.cQ ? this.cQ.result : null;
            },
            set: function set(newValue) {
                var selectedAnswer = this.cQ.answer.find(function (x) {
                    return x.value === newValue;
                });
                this.$set(this.cQ, 'resultText', selectedAnswer.text);
                this.$set(this.cQ, 'result', newValue);
            }
        },
        month: function month() {
            return Object(__WEBPACK_IMPORTED_MODULE_5__helpers_date_helpers__["f" /* formatDateByMonthLong */])(new Date(this.DBResults.date));
        },
        testRoute: function testRoute() {
            return this.testId.replace('Test ', '').toLocaleLowerCase().replace(' ', '-');
        }
    }, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapState */])('tests', ['resultInfo', 'DBResults']))
});

/***/ }),

/***/ 2451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_selfEvaluationTest_mixin__ = __webpack_require__(2449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_PatientsRepository__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_buttons_BaseButton_vue__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_icons_BaseIcon_vue__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_utils_WaveAnimation_vue__ = __webpack_require__(2499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_colours__ = __webpack_require__(46);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        BForm: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["m" /* BForm */],
        BModal: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_32" /* BModal */],
        BButton: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["d" /* BButton */],
        BProgress: __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["_43" /* BProgress */],
        BaseButton: __WEBPACK_IMPORTED_MODULE_6__components_base_buttons_BaseButton_vue__["default"],
        BaseIcon: __WEBPACK_IMPORTED_MODULE_7__components_base_icons_BaseIcon_vue__["a" /* default */],
        WaveAnimation: __WEBPACK_IMPORTED_MODULE_8__components_utils_WaveAnimation_vue__["a" /* default */]
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_selfEvaluationTest_mixin__["a" /* default */]],
    props: {
        testName: {
            type: String,
            required: true
        },
        testId: {
            type: String,
            required: true
        },
        test: {
            type: Array,
            required: true
        },
        opposedAnswers: {
            type: Array,
            required: false
        },
        multidimensional: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            started: false,
            goResults: false,
            songPlaying: true,
            BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_9__constants_colours__["c" /* BLUE_COLOUR */],
            iconSize: !this.$uiHelpers.isXlDevice ? '30' : '40'
        };
    },
    created: function created() {
        this.$store.state.tests = {
            test: this.randomizeTest(),
            currentSlide: 0,
            completed: false,
            previousTestResults: [],
            DBResults: {}
        };
        this.getPreviousResults();
    },

    methods: {
        startTest: function startTest() {
            this.started = true;
            this.$refs.song.play();
        },
        showResults: function showResults() {
            this.goResults = true;
            this.$refs.song.pause();
        },
        playPause: function playPause() {
            var s = this.$refs.song;
            if (s.paused) {
                s.play();
                this.songPlaying = true;
            } else {
                s.pause();
                this.songPlaying = false;
            }
        },
        getPreviousResults: function getPreviousResults() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var id, patientId;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                id = _this.$store.getters['session/userIsProfessional'] ? null : _this.$store.state.session.user.id;
                                patientId = _this.$store.getters['session/userIsProfessional'] ? _this.$route.params.patientId : null;

                                __WEBPACK_IMPORTED_MODULE_5__repositories_PatientsRepository__["a" /* default */].getPreviousMonthsResults(id, patientId, _this.testId).then(function (response) {
                                    _this.checkTestAlreadyCompletedThisMonth(response.data);
                                    if (_this.$store.getters['session/userIsProfessional'] && !_this.$store.state.tests.completed) {
                                        if (response.data.length) {
                                            _this.$store.commit('tests/setTestCompletedThisMonth', response.data[response.data.length - 1]);
                                            _this.goResults = true;
                                            _this.testResultsInfo(_this.testId);
                                        } else {
                                            _this.$router.push('/error/unauthorized?returnUrl=' + encodeURIComponent(window.location.href));
                                        }
                                    }
                                    _this.$store.commit('tests/setPreviousTestResults', response.data);
                                });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        checkTestAlreadyCompletedThisMonth: function checkTestAlreadyCompletedThisMonth(results) {
            var filteredTest = this.testId === __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["y" /* TEST_WORK_ENVIRONMENT */] ? this.checkTestAlreadyCompletedPastXMonths(results, 4) : this.checkTestAlreadyCompletedPastXMonths(results);
            if (filteredTest.length !== 1) return;
            if (this.$store.getters['session/userIsPatient'] && this.testId !== __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["t" /* TEST_PSYCHOSOCIAL_RISKS */] && this.testId !== __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["y" /* TEST_WORK_ENVIRONMENT */]) {
                this.$store.dispatch('showAlert', { text: this.$t('tests.alreadyCompletedMessage'), variant: 'secondary' });
            }
            this.goResults = true;
            this.$store.commit('tests/setTestCompletedThisMonth', filteredTest[0]);
            this.$store.commit('tests/setPreviousTestResults', results);
            this.testResultsInfo(this.testId);
            this.$emit('setFinishedMessageResultsHidden');
        },
        goToPastResults: function goToPastResults() {
            var pastResults = this.$store.state.tests.previousTestResults;
            this.goResults = true;
            this.$store.commit('tests/setTestCompletedThisMonth', pastResults[pastResults.length - 1]);
            this.testResultsInfo(this.testId);
        },
        checkTestAlreadyCompletedPastXMonths: function checkTestAlreadyCompletedPastXMonths(results) {
            var _this2 = this;

            var monthsNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            return results.filter(function (x) {
                var resultDate = new Date(x.date);

                var resultYear = resultDate.getFullYear();
                var resultMonth = resultDate.getMonth();

                var currentYear = _this2.date.getFullYear();
                var currentMonth = _this2.date.getMonth();

                var monthsDiff = (currentYear - resultYear) * 12 + (currentMonth - resultMonth);

                return monthsDiff >= 0 && monthsDiff < monthsNumber;
            });
        }
    },
    computed: {
        canSeePastResults: function canSeePastResults() {
            return this.$store.state.tests.previousTestResults.length && this.testId !== __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["t" /* TEST_PSYCHOSOCIAL_RISKS */] && this.testId !== __WEBPACK_IMPORTED_MODULE_4__constants_patientServices__["y" /* TEST_WORK_ENVIRONMENT */];
        },
        initialPage: function initialPage() {
            return !this.started && !this.$store.state.tests.completed && this.$store.getters['session/userIsPatient'];
        },
        questionsPage: function questionsPage() {
            return this.started && !this.$store.state.tests.completed;
        },
        goResultsPage: function goResultsPage() {
            return !this.goResults && this.$store.state.tests.completed;
        },
        resultsPage: function resultsPage() {
            return this.goResults && this.$store.state.tests.completed;
        }
    }
});

/***/ }),

/***/ 2484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionCard_vue__ = __webpack_require__(2448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_124970e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionCard_vue__ = __webpack_require__(2487);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2485)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_124970e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/QuestionCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-124970e4", Component.options)
  } else {
    hotAPI.reload("data-v-124970e4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2485:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2486);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("14defad2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-124970e4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./QuestionCard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-124970e4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./QuestionCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2486:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\ndiv.custom-radio.b-custom-control-lg:has(span:empty){margin-right:3%;margin-left:3%\n}\n@media only screen and (max-width: 575px){\ndiv.custom-radio.b-custom-control-lg:has(span:empty){margin:0.5%\n}\n}\n.custom-radio.b-custom-control-lg .custom-control-label::after{cursor:pointer !important\n}\n.slidesSize{width:100%;position:relative;z-index:1\n}\n.subtitle-card{color:#3238C4;font-weight:bold;font-size:1.25rem;white-space:normal\n}\n@media only screen and (max-width: 575px){\n.subtitle-card{font-size:1rem;display:inline-block\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 2487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.question
      ? _c(
          "div",
          { key: _vm.question.id, staticClass: "slidesSize" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mx-auto centered",
                    attrs: {
                      cols: "12",
                      md: _vm.fullWidthCard ? 12 : 10,
                      lg: _vm.fullWidthCard ? 12 : 8
                    }
                  },
                  [
                    _c(
                      "b-card",
                      { staticClass: "neu-card neu-card-sv" },
                      [
                        _vm._t("title"),
                        _vm._v(" "),
                        _c("h2", [_vm._v(_vm._s(_vm.question.question))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm._t("question"),
                            _vm._v(" "),
                            !_vm.$slots.question
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            class: [
                                              _vm.stacked
                                                ? "d-flex justify-content-center"
                                                : ""
                                            ]
                                          },
                                          [
                                            _c("radio-button", {
                                              class: [
                                                _vm.stacked
                                                  ? "text-left mx-auto centered"
                                                  : "mx-auto centered"
                                              ],
                                              staticStyle: {
                                                "box-sizing": "border-box"
                                              },
                                              attrs: {
                                                labelsEnabled:
                                                  _vm.labelsEnabled,
                                                options: _vm.question.answer,
                                                stacked: _vm.stacked
                                              },
                                              model: {
                                                value: _vm.localValue,
                                                callback: function($$v) {
                                                  _vm.localValue = $$v
                                                },
                                                expression: "localValue"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.stacked && !_vm.labelsEnabled
                                      ? _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "subtitle-card",
                                                attrs: {
                                                  cols: "6",
                                                  sm: "6",
                                                  lg: "3"
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.leastImportantAnswer
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "float-right subtitle-card ml-auto",
                                                attrs: {
                                                  cols: "6",
                                                  sm: "6",
                                                  lg: "3"
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.mostImportantAnswer
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("additionalComment"),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _vm.showButton
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "px-0 pt-1 px-md-5 pt-md-3 float-right m-auto",
                                        attrs: { xs: "12", lg: "8" }
                                      },
                                      [
                                        _c(
                                          "transition",
                                          {
                                            attrs: { name: "fade", appear: "" }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary w-100",
                                                attrs: { type: "button" },
                                                on: {
                                                  "~click": function($event) {
                                                    return _vm.action.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.questionText)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "float-right m-auto"
                                                  },
                                                  [
                                                    _c("base-icon", {
                                                      attrs: {
                                                        src:
                                                          "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                                        color: "white"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-124970e4", esExports)
  }
}

/***/ }),

/***/ 2488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = testToShow;
/* harmony export (immutable) */ __webpack_exports__["a"] = testRoute;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_patientServices__ = __webpack_require__(508);


function testToShow(companyServices, inMx) {
    var professionalOrCenter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var totalTests = __WEBPACK_IMPORTED_MODULE_0__constants_patientServices__["b" /* EVALUATE_HEALTH_TESTS */];
    if (professionalOrCenter) {
        return totalTests;
    }
    if (companyServices.length != 0) {
        return totalTests.filter(function (testId) {
            return companyServices.some(function (s) {
                return s.id === testId;
            });
        });
    } else {
        return totalTests.filter(function (testId) {
            return !__WEBPACK_IMPORTED_MODULE_0__constants_patientServices__["a" /* COMPANIES_TESTS */].some(function (item) {
                return item === testId;
            }) && !__WEBPACK_IMPORTED_MODULE_0__constants_patientServices__["f" /* ONLY_360_USERS_TESTS */].some(function (item) {
                return item === testId;
            });
        }).filter(function (testId) {
            return inMx ? !__WEBPACK_IMPORTED_MODULE_0__constants_patientServices__["e" /* NOT_IN_MX_TESTS */].some(function (item) {
                return item === testId;
            }) : true;
        });
    }
}

function testRoute(testId) {
    switch (true) {
        case testId === 'ryff-scale':
            return 'tests/bienestar-psicologico';
        default:
            return 'tests/' + testId;
    }
}

/***/ }),

/***/ 2492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestTemplate_vue__ = __webpack_require__(2451);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc4bc35a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestTemplate_vue__ = __webpack_require__(2503);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2497)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc4bc35a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/selfEvaluationTests/TestTemplate.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cc4bc35a", Component.options)
  } else {
    hotAPI.reload("data-v-cc4bc35a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2497:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2498);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("5fa0d703", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cc4bc35a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TestTemplate.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cc4bc35a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TestTemplate.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2498:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n@media only screen and (min-width: 1024px){\n.self-evaluation-test-styles .test-container{min-height:60dvh\n}\n}\n@media only screen and (min-width: 2000px){\n.self-evaluation-test-styles .test-container{min-height:70dvh\n}\n}\n.self-evaluation-test-styles .slidesSize{width:100%;position:relative;z-index:1;padding-bottom:7rem\n}\n.self-evaluation-test-styles .topDiv{text-align:center;margin-bottom:0.2rem\n}\n@media only screen and (max-width: 575px){\n.self-evaluation-test-styles .topDiv{margin-left:1.5rem\n}\n}\n.self-evaluation-test-styles .topDiv div{display:inline-block\n}\n.self-evaluation-test-styles .testProgressBar{height:0.2rem;margin-bottom:7rem\n}\n@media only screen and (max-width: 575px){\n.self-evaluation-test-styles .testProgressBar{margin-bottom:3rem\n}\n}\n.self-evaluation-test-styles .fade-enter-active,.self-evaluation-test-styles .fade-leave-active{-webkit-transition:opacity 0.6s ease;transition:opacity 0.6s ease\n}\n.self-evaluation-test-styles .fade-enter-from,.self-evaluation-test-styles .fade-leave-to{opacity:0\n}\n.self-evaluation-test-styles .neu-card{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#eee;border-radius:23px !important;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);height:100%;border:0px !important;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:10px;text-align:center\n}\n.self-evaluation-test-styles .neu-card h2{color:#1D1D1E\n}\n@media only screen and (min-width: 1024px){\n.self-evaluation-test-styles .neu-card{padding:1rem 2rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.self-evaluation-test-styles .neu-card{padding:1rem 2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.self-evaluation-test-styles .neu-card{padding:1rem 2rem\n}\n}\n@media only screen and (max-width: 575px){\n.self-evaluation-test-styles .neu-card{padding:1rem 1rem\n}\n.self-evaluation-test-styles .neu-card h2{font-size:1.3rem\n}\n}\n.self-evaluation-test-styles .neu-card.mean-result{margin:1.5rem auto 1.5rem;background-color:#3238C4\n}\n.self-evaluation-test-styles .mean-result .subtitle-card{color:#eee\n}\n.self-evaluation-test-styles .results-container{text-align:center\n}\n@media only screen and (max-width: 575px){\n.self-evaluation-test-styles .results-container{margin-top:1.5rem\n}\n}\n.self-evaluation-test-styles .results-card{margin:1rem auto 1rem;display:inline-block\n}\n@media only screen and (max-width: 575px){\n.self-evaluation-test-styles .results-card{margin:auto;margin-bottom:1.5rem\n}\n}\n.self-evaluation-test-styles .subtitle-card{color:#3238C4;font-weight:bold;font-size:1.25rem;white-space:normal\n}\n@media only screen and (max-width: 575px){\n.self-evaluation-test-styles .subtitle-card{font-size:1rem;display:inline-block\n}\n}\n.self-evaluation-test-styles .barChart{height:200px;margin-bottom:3rem\n}\n@media only screen and (max-width: 575px){\n.self-evaluation-test-styles .barChart{height:130px\n}\n}\n.self-evaluation-test-styles .donut{height:15rem;-webkit-box-sizing:border-box;box-sizing:border-box;margin-right:2rem\n}\n@media only screen and (max-width: 1000px){\n.self-evaluation-test-styles .donut{margin-right:0;margin-top:1rem\n}\n}\n.self-evaluation-test-styles .p-white{color:#eee;text-align:justify\n}\n.self-evaluation-test-styles .highcharts-container{margin:0 auto\n}\n.self-evaluation-test-styles .collapsed .accordion-arrow-open,.self-evaluation-test-styles .not-collapsed .accordion-arrow-closed{display:none\n}\n.self-evaluation-test-styles .inputAnswer{width:14rem;margin:1.5rem 0.5rem 0rem\n}\n@media only screen and (max-width: 768px){\n.self-evaluation-test-styles .inputAnswer{width:100%\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 2499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd1cc9a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaveAnimation_vue__ = __webpack_require__(2502);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2500)
}
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd1cc9a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd1cc9a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaveAnimation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/WaveAnimation.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cd1cc9a6", Component.options)
  } else {
    hotAPI.reload("data-v-cd1cc9a6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2500:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2501);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("e360a410", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cd1cc9a6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WaveAnimation.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cd1cc9a6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./WaveAnimation.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2501:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-cd1cc9a6]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-cd1cc9a6],.slide-down-leave-active[data-v-cd1cc9a6]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-cd1cc9a6],.slide-down-leave-to[data-v-cd1cc9a6]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-cd1cc9a6],.slide-fade-left-leave-active[data-v-cd1cc9a6]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-cd1cc9a6],.slide-fade-left-leave-to[data-v-cd1cc9a6]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-cd1cc9a6]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-cd1cc9a6],.fade-leave-to[data-v-cd1cc9a6]{opacity:0\n}\n@-webkit-keyframes move_wave-data-v-cd1cc9a6{\n0%{-webkit-transform:translateX(0) translateZ(0) scaleY(1);transform:translateX(0) translateZ(0) scaleY(1)\n}\n50%{-webkit-transform:translateX(-25%) translateZ(0) scaleY(0.55);transform:translateX(-25%) translateZ(0) scaleY(0.55)\n}\n100%{-webkit-transform:translateX(-50%) translateZ(0) scaleY(1);transform:translateX(-50%) translateZ(0) scaleY(1)\n}\n}\n@keyframes move_wave-data-v-cd1cc9a6{\n0%{-webkit-transform:translateX(0) translateZ(0) scaleY(1);transform:translateX(0) translateZ(0) scaleY(1)\n}\n50%{-webkit-transform:translateX(-25%) translateZ(0) scaleY(0.55);transform:translateX(-25%) translateZ(0) scaleY(0.55)\n}\n100%{-webkit-transform:translateX(-50%) translateZ(0) scaleY(1);transform:translateX(-50%) translateZ(0) scaleY(1)\n}\n}\n.waveWrapper[data-v-cd1cc9a6]{padding:0 !important;margin-bottom:-3rem;overflow:hidden;width:100%\n}\n.waveWrapperInner[data-v-cd1cc9a6]{position:absolute;overflow:hidden;width:140%;height:100%;bottom:0\n}\n@media only screen and (min-width: 1024px){\n.waveWrapperInner[data-v-cd1cc9a6]{right:-9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.waveWrapperInner[data-v-cd1cc9a6]{right:-20rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.waveWrapperInner[data-v-cd1cc9a6]{right:-9rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.waveWrapperInner[data-v-cd1cc9a6]{right:-6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.waveWrapperInner[data-v-cd1cc9a6]{right:-6rem\n}\n}\n@media only screen and (max-width: 575px){\n.waveWrapperInner[data-v-cd1cc9a6]{right:-2rem\n}\n}\n.bgTop[data-v-cd1cc9a6]{z-index:-1;opacity:0.5\n}\n.bgMiddle[data-v-cd1cc9a6]{z-index:-2;opacity:0.75\n}\n.bgBottom[data-v-cd1cc9a6]{z-index:-3\n}\n.wave[data-v-cd1cc9a6]{position:absolute;width:200%;height:100%;background-repeat:repeat no-repeat;background-position:0 bottom;-webkit-transform-origin:center bottom;transform-origin:center bottom;background-image:url(\"/static-appopensalud/img/bgs/waveBackground.svg\")\n}\n.waveTop[data-v-cd1cc9a6]{background-size:50% 100px\n}\n.waveAnimation .waveTop[data-v-cd1cc9a6]{animation:move-wave 3s;-webkit-animation:move-wave 3s;-webkit-animation-delay:1s;animation-delay:1s\n}\n.waveMiddle[data-v-cd1cc9a6]{background-size:50% 120px\n}\n.waveAnimation .waveMiddle[data-v-cd1cc9a6]{-webkit-animation:move_wave-data-v-cd1cc9a6 9s linear infinite;animation:move_wave-data-v-cd1cc9a6 9s linear infinite\n}\n.waveBottom[data-v-cd1cc9a6]{background-size:50% 100px\n}\n.waveAnimation .waveBottom[data-v-cd1cc9a6]{-webkit-animation:move_wave-data-v-cd1cc9a6 14s linear infinite;animation:move_wave-data-v-cd1cc9a6 14s linear infinite\n}\n", ""]);

// exports


/***/ }),

/***/ 2502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waveWrapper waveAnimation" },
    _vm._l(["Top", "Middle", "Bottom"], function(className) {
      return _c(
        "div",
        {
          key: className,
          staticClass: "waveWrapperInner",
          class: "bg" + className
        },
        [_c("div", { staticClass: "wave", class: "wave" + className })]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd1cc9a6", esExports)
  }
}

/***/ }),

/***/ 2503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "self-evaluation-test-styles" },
    [
      _c("loading-anim", {
        attrs: { active: _vm.$store.state.loading, fullScreen: "" }
      }),
      _vm._v(" "),
      _c("audio", {
        ref: "song",
        attrs: {
          id: "music",
          loop: "",
          src: "/static-appopensalud/audio/meditationSong.mp3"
        }
      }),
      _vm._v(" "),
      _vm.initialPage
        ? _c(
            "div",
            { staticClass: "test-container" },
            [
              _c("b-row", [_c("h2", [_vm._v(_vm._s(_vm.testName))]), _c("br")]),
              _vm._v(" "),
              _c("b-row", { staticClass: "mb-md-4 mb-sm-2 m-auto" }, [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("tests." + _vm.testRoute + ".description")
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "p-2 m-auto text-center",
                      attrs: { xs: "12", sm: "12", md: "6", lg: "6", xl: "6" }
                    },
                    [
                      _c(
                        "b-card",
                        { staticClass: "neu-card" },
                        [
                          _c("base-icon", {
                            staticClass: "d-block mb-3",
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/primary/pencil-icon-blue.svg",
                              height: _vm.iconSize,
                              width: _vm.iconSize,
                              color: _vm.BLUE_COLOUR
                            }
                          }),
                          _vm._v(" "),
                          _c("base-button", { on: { click: _vm.startTest } }, [
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.$t("tests.startTest")) + " "
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.canSeePastResults
                    ? _c(
                        "b-col",
                        {
                          staticClass: "p-2",
                          attrs: {
                            xs: "12",
                            sm: "12",
                            md: "6",
                            lg: "6",
                            xl: "6"
                          }
                        },
                        [
                          _c(
                            "b-card",
                            { staticClass: "neu-card" },
                            [
                              _c("base-icon", {
                                staticClass: "d-block mb-3",
                                attrs: {
                                  src:
                                    "/static-appopensalud/img/icons/morillas-svg-icons/primary/bars.svg",
                                  height: _vm.iconSize,
                                  width: _vm.iconSize,
                                  color: _vm.BLUE_COLOUR
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "base-button",
                                { on: { click: _vm.goToPastResults } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("tests.previousResults")
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.questionsPage
          ? _c(
              "div",
              { key: _vm.$store.state.tests.currentSlide },
              [
                _c(
                  "div",
                  { staticClass: "test-container" },
                  [
                    _c("div", { staticClass: "topDiv" }, [
                      _c("div", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              parseInt(
                                (_vm.$store.state.tests.currentSlide * 100) /
                                  _vm.$store.state.tests.test.length
                              )
                            ) +
                              "% " +
                              _vm._s(_vm.$t("tests.completed"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "float-right" }, [
                        _c(
                          "button",
                          {
                            staticStyle: {
                              "background-color": "transparent",
                              border: "none"
                            },
                            on: { click: _vm.playPause }
                          },
                          [
                            _c("b-icon", {
                              attrs: {
                                icon: _vm.songPlaying
                                  ? "volume-up-fill"
                                  : "volume-mute-fill"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("b-progress", {
                      staticClass: "testProgressBar",
                      staticStyle: { height: "0.2rem" },
                      attrs: {
                        value: _vm.$store.state.tests.currentSlide,
                        max: _vm.$store.state.tests.test.length
                      }
                    }),
                    _vm._v(" "),
                    _vm._t("questions")
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "fade", appear: "" } },
                  [!_vm.resultsPage ? _c("wave-animation") : _vm._e()],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.goResultsPage
          ? _c(
              "div",
              { staticClass: "slidesSize" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "px-0 pt-1 px-md-5 pt-md-2 m-auto text-center",
                    attrs: { xs: "12", lg: "8" }
                  },
                  [
                    _c("h3", [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.$t("tests.congratulations")) +
                            " " +
                            _vm._s(_vm.$store.state.session.user.name)
                        )
                      ])
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("h4", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("tests.testCompleted"))
                      }
                    }),
                    _c("br"),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit" },
                        on: { click: _vm.showResults }
                      },
                      [
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.$t("tests.finishTest")) + " ")
                        ])
                      ]
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.resultsPage
          ? _c(
              "div",
              { key: "results", staticClass: "test-container" },
              [_vm._t("results")],
              2
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc4bc35a", esExports)
  }
}

/***/ }),

/***/ 3327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralHealthTest_vue__ = __webpack_require__(3328);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19096a7f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralHealthTest_vue__ = __webpack_require__(3909);
var disposed = false
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeneralHealthTest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19096a7f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeneralHealthTest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/selfEvaluationTests/GeneralHealthTest.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-19096a7f", Component.options)
  } else {
    hotAPI.reload("data-v-19096a7f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TestTemplate_vue__ = __webpack_require__(2492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_selfEvaluationTest_mixin__ = __webpack_require__(2449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_patientServices__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_colours__ = __webpack_require__(46);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_selfEvaluationTest_mixin__["a" /* default */]],
    components: {
        'test-template': __WEBPACK_IMPORTED_MODULE_1__TestTemplate_vue__["default"],
        'gauge-chart': function gaugeChart() {
            return __webpack_require__.e/* import() */(117/* duplicate */).then(__webpack_require__.bind(null, 2657));
        },
        'column-chart': function columnChart() {
            return __webpack_require__.e/* import() */(118/* duplicate */).then(__webpack_require__.bind(null, 2648));
        }
    },
    data: function data() {
        var answers = {
            limitations: [{ value: 100, text: this.$t('tests.answers.limitNone') }, { value: 50, text: this.$t('tests.answers.limitABit') }, { value: 0, text: this.$t('tests.answers.limitALot') }],
            healthState: [{ value: 0, text: this.$t('tests.answers.bad') }, { value: 25, text: this.$t('tests.answers.regular') }, { value: 50, text: this.$t('tests.answers.good') }, { value: 75, text: this.$t('tests.answers.veryGood') }, { value: 100, text: this.$t('tests.answers.excelent') }],
            interference: [{ value: 100, text: this.$t('tests.answers.no') }, { value: 0, text: this.$t('tests.answers.yes') }],
            healthStateMomentum: [{ value: 0, text: this.$t('tests.answers.muchWorseNow') }, { value: 25, text: this.$t('tests.answers.someWorseNow') }, { value: 50, text: this.$t('tests.answers.moreOrLessTheSame') }, { value: 75, text: this.$t('tests.answers.someBetterNow') }, { value: 100, text: this.$t('tests.answers.muchBetterNow') }],
            time: [{ value: 0, text: this.$t('tests.answers.never') }, { value: 20, text: this.$t('tests.answers.almostNever') }, { value: 40, text: this.$t('tests.answers.sometimes') }, { value: 60, text: this.$t('tests.answers.alot') }, { value: 80, text: this.$t('tests.answers.alot2') }, { value: 100, text: this.$t('tests.answers.always') }],
            partialTime: [{ value: 100, text: this.$t('tests.answers.never') }, { value: 75, text: this.$t('tests.answers.almostNever') }, { value: 50, text: this.$t('tests.answers.sometimes') }, { value: 25, text: this.$t('tests.answers.alot2') }, { value: 0, text: this.$t('tests.answers.always') }],
            painInterference: [{ value: 100, text: this.$t('tests.answers.nothingAtAll') }, { value: 75, text: this.$t('tests.answers.veryLittle') }, { value: 50, text: this.$t('tests.answers.moderately') }, { value: 25, text: this.$t('tests.answers.prettyMuch') }, { value: 0, text: this.$t('tests.answers.extremately') }],
            agreementLevel: [{ value: 0, text: this.$t('tests.answers.total-disagreement') }, { value: 25, text: this.$t('tests.answers.disagreement') }, { value: 50, text: this.$t('tests.answers.agreement-disagreement') }, { value: 75, text: this.$t('tests.answers.agreement') }, { value: 100, text: this.$t('tests.answers.total-agreement') }],
            pain: [{ value: 100, text: this.$t('tests.answers.noneMasculine') }, { value: 80, text: this.$t('tests.answers.verySlight') }, { value: 60, text: this.$t('tests.answers.slight') }, { value: 40, text: this.$t('tests.answers.moderate') }, { value: 20, text: this.$t('tests.answers.severe') }, { value: 0, text: this.$t('tests.answers.verySevere') }]
        };

        var test = [{
            dimension: 'tests.general-health.dimensions.physical-function',
            qs: ['q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10', 'q11', 'q12']
        }, {
            dimension: 'tests.general-health.dimensions.physical-limitations',
            qs: ['q13', 'q14', 'q15', 'q16'],
            opposedDirection: true
        }, {
            dimension: 'tests.general-health.dimensions.body-pain',
            qs: ['q21', 'q22'],
            opposedDirection: true
        }, {
            dimension: 'tests.general-health.dimensions.general-health',
            qs: ['q1', 'q2', 'q33', 'q34', 'q35', 'q36']
        }, {
            dimension: 'tests.general-health.dimensions.vitality',
            qs: ['q23', 'q27', 'q29', 'q31']
        }, {
            dimension: 'tests.general-health.dimensions.social-function',
            qs: ['q20', 'q32']
        }, {
            dimension: 'tests.general-health.dimensions.emotional-limitations',
            qs: ['q17', 'q18', 'q19'],
            opposedDirection: true
        }, {
            dimension: 'tests.general-health.dimensions.mental-health',
            qs: ['q24', 'q25', 'q26', 'q28', 'q30']
        }];

        var opposedAnswers = ['q24', 'q25', 'q28', 'q29', 'q31', 'q33', 'q35'];

        return {
            test: test,
            testId: __WEBPACK_IMPORTED_MODULE_3__constants_patientServices__["o" /* TEST_GENERAL_HEALTH */],
            opposedAnswers: opposedAnswers,
            testName: this.$t('tests.general-health.title'),
            multidimensional: true,
            answers: answers
        };
    },
    created: function created() {
        this.createQuestions();
    },

    methods: {
        createQuestions: function createQuestions() {
            var _this = this;

            var dimIndex = 1;
            this.test.map(function (dimension) {
                dimension.id = 'apartado-' + dimIndex;
                var questions = [];
                dimension.qs.map(function (qx) {
                    return questions.push({
                        id: qx,
                        question: _this.$t('tests.general-health.questions.' + qx),
                        answer: _this.setQuestionAnswer(qx),
                        result: null
                    });
                });
                dimIndex = dimIndex + 1;
                _this.$set(dimension, 'questions', questions);
            });
        },
        setQuestionAnswer: function setQuestionAnswer(question) {
            switch (true) {
                case question === 'q1':
                    return this.answers.healthState;
                case question === 'q2':
                    return this.answers.healthStateMomentum;
                case ['q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9', 'q10', 'q11', 'q12'].includes(question):
                    return this.answers.limitations;
                case ['q13', 'q14', 'q15', 'q16', 'q17', 'q18', 'q19'].includes(question):
                    return this.answers.interference;
                case ['q23', 'q24', 'q25', 'q26', 'q27', 'q28', 'q29', 'q30', 'q31'].includes(question):
                    return this.answers.time;
                case ['q20', 'q22'].includes(question):
                    return this.answers.painInterference;
                case question === 'q21':
                    return this.answers.pain;
                case question === 'q32':
                    return this.answers.partialTime;
                case ['q33', 'q34', 'q35', 'q36'].includes(question):
                    return this.answers.agreementLevel;
            }
        },
        saveTestResults: function saveTestResults() {
            var dimensions = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.test), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var dimension = _step.value;

                    var dimensionValues = this.calculateMultidimensionalDimPoints(dimension);
                    var percentage = Math.round(dimensionValues.sum / dimension.questions.length);
                    var result = dimension.opposedDirection ? 100 - percentage : percentage;
                    dimensions.push({ 'result': result, 'id': dimension.id, 'name': dimension.dimension, 'points': dimensionValues.sum, 'totalDimensionPoints': dimensionValues.total });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.save(dimensions, Math.round(dimensions.map(function (x) {
                return x.points;
            }).reduce(function (x, y) {
                return x + y;
            }, 0) / 36));
        },
        interpretationColor: function interpretationColor(dimensionName, r) {
            var dimension = this.test.find(function (item) {
                return item.dimension === dimensionName;
            });
            return this.setColor(r, dimension.opposedDirection);
        },
        setColor: function setColor(r) {
            var opposedDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (opposedDirection) r = 100 - r;
            return r >= 85 ? __WEBPACK_IMPORTED_MODULE_4__constants_colours__["g" /* GREEN_COLOUR */] : r >= 70 ? __WEBPACK_IMPORTED_MODULE_4__constants_colours__["h" /* GREEN_LIGHT_COLOUR */] : r >= 50 ? __WEBPACK_IMPORTED_MODULE_4__constants_colours__["n" /* YELLOW_COLOUR */] : r >= 35 ? __WEBPACK_IMPORTED_MODULE_4__constants_colours__["j" /* ORANGE_MID_COLOUR */] : __WEBPACK_IMPORTED_MODULE_4__constants_colours__["k" /* RED_COLOUR */];
        },
        dimensionResult: function dimensionResult(dimensionName, points, dimensionPoints) {
            var dimension = this.test.find(function (item) {
                return item.dimension === dimensionName;
            });
            if (dimension.opposedDirection || false) {
                points = dimensionPoints - points;
            }
            return points + '/' + dimensionPoints;
        }
    },
    computed: {
        physicalHealthMeanResult: function physicalHealthMeanResult() {
            return Math.round(this.DBResults.dimensions.slice(0, 4).map(function (x) {
                return Math.round(x.points * 100 / x.totalDimensionPoints);
            }).reduce(function (x, y) {
                return x + y;
            }, 0) / 4);
        },
        mentalHealthMeanResult: function mentalHealthMeanResult() {
            return Math.round(this.DBResults.dimensions.slice(4, 8).map(function (x) {
                return Math.round(x.points * 100 / x.totalDimensionPoints);
            }).reduce(function (x, y) {
                return x + y;
            }, 0) / 4);
        }
    }
});

/***/ }),

/***/ 3909:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("test-template", {
        attrs: {
          testName: _vm.testName,
          testId: _vm.testId,
          test: _vm.test,
          opposedAnswers: _vm.opposedAnswers,
          multidimensional: ""
        },
        scopedSlots: _vm._u([
          {
            key: "questions",
            fn: function() {
              return [
                _c("question-card", {
                  attrs: {
                    question: _vm.cQ,
                    progress: _vm.$store.state.tests.currentSlide,
                    questionnaireLength: _vm.$store.state.tests.test.length
                  },
                  on: {
                    answerQuestion: function() {
                      _vm.$store.commit("tests/incrementSlide")
                    },
                    submitQuestionnaire: _vm.saveTestResults
                  },
                  model: {
                    value: _vm.questionResult,
                    callback: function($$v) {
                      _vm.questionResult = $$v
                    },
                    expression: "questionResult"
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "results",
            fn: function() {
              return [
                _c(
                  "div",
                  { key: "topGraph", staticClass: "first" },
                  [
                    _c("h3", { staticClass: "subtitle-card text-center" }, [
                      _vm._v(
                        _vm._s(_vm.$t("tests.testResults")) +
                          " - " +
                          _vm._s(_vm.testName.toUpperCase())
                      )
                    ]),
                    _vm._v(" "),
                    _c("column-chart", {
                      attrs: {
                        lastYearResults: _vm.$store.state.tests.previousTestResults.slice(
                          -12
                        ),
                        testName: _vm.testName
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { key: "recapCard", staticClass: "second" },
                  [
                    _c("h4", [
                      _vm._v(
                        _vm._s(_vm.$t("tests.results")) +
                          " " +
                          _vm._s(_vm.month)
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-card",
                      { staticClass: "neu-card mean-result col-lg-7" },
                      [
                        _c(
                          "b-row",
                          { staticClass: "h-100" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "align-self-center",
                                attrs: { lg: "5" }
                              },
                              [
                                _c("h3", { staticClass: "subtitle-card" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.testName.toUpperCase())
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "my-auto", attrs: { lg: "7" } },
                              [
                                _c("gauge-chart", {
                                  attrs: {
                                    labels: [_vm.testName],
                                    result: _vm.DBResults.generalResult
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "p-2",
                            attrs: { cols: "12", md: "6" }
                          },
                          [
                            _c(
                              "b-card",
                              {
                                staticClass: "neu-card",
                                attrs: {
                                  title: _vm.$t("tests.physical-health")
                                }
                              },
                              [
                                _c("b-icon-circle-fill", {
                                  style:
                                    "color: " +
                                    _vm.setColor(_vm.physicalHealthMeanResult)
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.physicalHealthMeanResult) + "%"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("hr", { staticClass: "mt-2" }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.DBResults.dimensions.slice(0, 4),
                                  function(d) {
                                    return _c(
                                      "b-row",
                                      { key: d.name },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "text-left",
                                            attrs: { cols: "9" }
                                          },
                                          [
                                            _c("strong", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(d.name)
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "align-self-center",
                                            attrs: { cols: "3" }
                                          },
                                          [
                                            _c("b-icon-circle-fill", {
                                              style:
                                                "color: " +
                                                _vm.interpretationColor(
                                                  d.name,
                                                  d.result
                                                )
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(d.result) + "%")
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            staticClass: "p-2",
                            attrs: { cols: "12", md: "6" }
                          },
                          [
                            _c(
                              "b-card",
                              {
                                staticClass: "neu-card",
                                attrs: { title: _vm.$t("tests.mental-health") }
                              },
                              [
                                _c("b-icon-circle-fill", {
                                  style:
                                    "color: " +
                                    _vm.setColor(_vm.mentalHealthMeanResult)
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.mentalHealthMeanResult) + "%"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("hr", { staticClass: "mt-2" }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.DBResults.dimensions.slice(4, 8),
                                  function(d) {
                                    return _c(
                                      "b-row",
                                      { key: d.name },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "text-left",
                                            attrs: { cols: "9" }
                                          },
                                          [
                                            _c("strong", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(d.name)
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _c(
                                          "b-col",
                                          {
                                            staticClass: "align-self-center",
                                            attrs: { cols: "3" }
                                          },
                                          [
                                            _c("b-icon-circle-fill", {
                                              style:
                                                "color: " +
                                                _vm.interpretationColor(
                                                  d.name,
                                                  d.result
                                                )
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(_vm._s(d.result) + "%")
                                            ])
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19096a7f", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/135.6a43e8220709fa62fab4.js